import { IMunicipio } from "@/interfaces/IMunicipio";
import { api } from "@/services/api";
import { useAuth } from "react-oidc-context";

export const useMunicipio = () => {
  const { user } = useAuth();

  const getMunicipiosMt = async () => {
    const { data } = await api.get<IMunicipio[]>("/municipios/todos", {
      headers: {
        Authorization: `Bearer ${user?.access_token}`,
      },
    });

    return data;
  };

  return { getMunicipiosMt };
};
